module.exports = __webpack_public_path__ + "img/monitor.e5b7295e.png";